var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-list-item",
    {
      attrs: { title: _vm.file.filename },
      on: {
        change: function ($event) {
          return _vm.$emit("changed-files")
        },
        click: function ($event) {
          $event.stopPropagation()
          return _vm.select_file_exclusive.apply(null, arguments)
        },
      },
    },
    [
      _c(
        "v-list-item-action",
        {
          on: {
            click: function ($event) {
              $event.stopPropagation()
              return _vm.select_file.apply(null, arguments)
            },
          },
        },
        [
          _c("v-checkbox", {
            attrs: { "input-value": _vm.selected, color: "blue" },
          }),
        ],
        1
      ),
      _c(
        "v-list-item-avatar",
        [_c("v-icon", { attrs: { small: "" } }, [_vm._v(_vm._s(_vm.icon))])],
        1
      ),
      _c(
        "v-list-item-content",
        [_c("v-list-item-title", [_vm._v(_vm._s(_vm.file.filename))])],
        1
      ),
      _vm.serverMode
        ? _c(
            "v-list-item-action",
            {
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  return _vm.save_file.apply(null, arguments)
                },
              },
            },
            [
              _c(
                "v-btn",
                {
                  attrs: {
                    "data-cy": "saveFile",
                    icon: "",
                    small: "",
                    disabled: _vm.disable_saving,
                  },
                },
                [
                  _c(
                    "v-icon",
                    { attrs: { title: "Save entry to the database" } },
                    [_vm._v(" mdi-content-save ")]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "v-list-item-action",
        {
          on: {
            click: function ($event) {
              $event.stopPropagation()
              return _vm.remove_file.apply(null, arguments)
            },
          },
        },
        [
          _c(
            "v-btn",
            { attrs: { "data-cy": "closeFile", icon: "", small: "" } },
            [
              _c(
                "v-icon",
                { attrs: { title: "Remove entry from result set" } },
                [_vm._v(" mdi-playlist-remove ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }